// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Resources } from '@shared/localizations/Resources';
import { MainWindowManager } from '../UtilsClasses/MainWindowManager';
import { HtmlScroll } from '@components/webdesktop/elements/Scroll/HtmlScroll';
import EntitlementSubscribeDocumentScreenTemplate from '@front/templates/EntitlementSubscribeDocumentScreenTemplate.html';
import { TerceraWindowBase } from './TerceraWindowBase';
import { entitlementSubscribeDocumentScreenHandler } from '@shared/utils/AppHandlers';
import { EntitlementManager } from '@shared/commons/cache/Entitlement/EntitlementManager';
export class EntitlementSubscribeDocumentScreen extends TerceraWindowBase {
    constructor() {
        super(...arguments);
        this.ProductID = null;
        this.DocumentArray = [];
        this.doneWasClicked = false;
        this.needSendRequestOnDoneClick = true;
        this.customDisposeHandler = null;
    }
    getType() {
        return 'EntitlementSubscribeDocumentScreen';
    }
    oncomplete() {
        super.oncomplete();
        this.OnResize.Subscribe(this.resizingProcess, this);
        this.on('nextClick', this.nextClick);
        this.on('backClick', this.backClick);
        this.on('doneClick', this.doneClick);
        this.observe('text_middle_obs', (newValue) => {
            void this.set({ text_middle: newValue });
        });
        this.addScroll();
        this.localize();
        this.updateHeader();
        this.updateProgressBar();
        this.center();
        this.getContentDocument();
        this.getInputDocument();
    }
    resizingProcess() {
        const width = this.get('width');
        const height = this.get('height');
        const middleHeight = height - 25 - 48 - 97; // header - js-products-document-top - js-products-document-bottom
        void this.set({
            widthPanel: width,
            heightPanel: middleHeight
        });
        this.updateProgressBar();
    }
    setDocumentParam() {
        const arr = this.DocumentArray;
        const index = this.get('currentStep') - 1;
        void this.set({
            stepsCount: arr.length,
            text_top: arr[index].Name,
            text_middle_obs: arr[index].Content
        });
    }
    nextClick() {
        const arr = this.DocumentArray;
        let currentStep = this.get('currentStep');
        ++currentStep;
        this.SaveDocument();
        void this.set({
            currentStep: currentStep,
            text_top: arr[currentStep - 1].Name,
            text_middle_obs: arr[currentStep - 1].Content
        });
        this.getContentDocument();
        this.getInputDocument();
        this.updateHeader();
        this.updateProgressBar();
        this.resetScroll();
    }
    backClick() {
        const arr = this.DocumentArray;
        let currentStep = this.get('currentStep');
        currentStep--;
        this.SaveDocument();
        void this.set({
            currentStep: currentStep,
            text_top: arr[currentStep - 1].Name,
            text_middle_obs: arr[currentStep - 1].Content
        });
        this.getContentDocument();
        this.getInputDocument();
        this.updateHeader();
        this.updateProgressBar();
        this.resetScroll();
    }
    doneClick() {
        this.doneWasClicked = true;
        this.SaveDocument();
        if (this.needSendRequestOnDoneClick) {
            EntitlementManager.ProductSubscribeRequest(this.ProductID, this.DocumentArray);
        }
        this.close();
    }
    dispose() {
        if (!isNullOrUndefined(this.customDisposeHandler)) {
            this.customDisposeHandler(this.doneWasClicked);
        }
        this.OnResize.UnSubscribe(this.resizingProcess, this);
        this.removeScroll();
        super.dispose();
    }
    SaveDocument() {
        const arr = this.DocumentArray;
        const index = this.get('currentStep') - 1;
        arr[index].Content =
            this.Controls.windowPanelBody.el.getElementsByClassName('js-label-document-middle')[0].innerHTML;
    }
    getContentDocument() {
        const arr = this.DocumentArray;
        const index = this.get('currentStep') - 1;
        let sumH = 0;
        if (arr[index].Content.indexOf('<style>') != -1) {
            const iframe = document.createElement('iframe');
            document.body.appendChild(iframe);
            const doc = iframe.contentDocument;
            doc.write(arr[index].Content);
            doc.close();
            const children = doc.body.children;
            for (let i = 0; i < children.length; i++) {
                const child = children[i];
                sumH += child.clientHeight;
            }
            document.body.removeChild(iframe);
        }
        void this.set({ heightContent: sumH });
    }
    addScroll() {
        this.scroll = HtmlScroll.addScroll(this.find('.js-products-document-middle'), 'xy');
    }
    removeScroll() {
        var _a;
        (_a = this.scroll) === null || _a === void 0 ? void 0 : _a.destroy();
    }
    resetScroll() {
        this.removeScroll();
        this.addScroll();
    }
    checkNextBTNEnability(radio, text, checkbox) {
        const keys = Object.keys(radio);
        let r = true;
        for (let i = 0; i < keys.length; i++) {
            const key = keys[i];
            const arr = radio[key];
            let sR = false;
            for (let j = 0; j < arr.length; j++) {
                if (arr[j].checked) {
                    sR = true;
                    break;
                }
            }
            r = r && sR;
        }
        let t = true;
        for (let i = 0; i < text.length; i++) {
            const value = text[i].value;
            t = t && !!value;
        }
        let c = true;
        for (let i = 0; i < checkbox.length; i++) {
            c = c && checkbox[i].checked;
        }
        const enabled = r && t && c;
        const tooltip = this.getBTNTooltip(enabled);
        void this.set({
            canEnabledBTN: enabled,
            btnTooltip: tooltip
        });
    }
    getBTNTooltip(enabled) {
        if (!enabled) {
            return Resources.getResource('screen.documets.Button.ToolTip');
        }
        else {
            return '';
        }
    }
    getInputDocument() {
        const me = this;
        const rootElement = this.Controls.windowPanelBody.el.getElementsByClassName('js-label-document-middle')[0];
        if (isNullOrUndefined(rootElement)) {
            return;
        }
        const imputDocument = rootElement.getElementsByTagName('input'); // найти инпуты все
        const comboBoxDocument = rootElement.getElementsByTagName('select'); // найти комбо-боксы
        const linkDocument = rootElement.getElementsByTagName('a'); // найти линки
        const radioInput = {};
        const textInput = [];
        const checkInput = [];
        for (let i = 0; i < imputDocument.length; i++) {
            const ipD = imputDocument[i];
            if (ipD.type === 'radio') {
                ipD.oninput = function () {
                    var _a;
                    const arr = (_a = radioInput[this.name]) !== null && _a !== void 0 ? _a : [];
                    for (i = 0; i < arr.length; i++) {
                        arr[i].removeAttribute('checked');
                    }
                    this.setAttribute('checked', '');
                    me.checkNextBTNEnability(radioInput, textInput, checkInput);
                };
                if (!isValidArray(radioInput[ipD.name])) {
                    radioInput[ipD.name] = [];
                }
                radioInput[ipD.name].push(ipD);
            }
            if (ipD.type === 'text') {
                ipD.oninput = function () {
                    this.setAttribute('value', this.value);
                    me.checkNextBTNEnability(radioInput, textInput, checkInput);
                };
                textInput.push(ipD);
            }
            if (ipD.type === 'checkbox') {
                ipD.oninput = function () {
                    this.setAttribute('checked', this.checked);
                    me.checkNextBTNEnability(radioInput, textInput, checkInput);
                };
                checkInput.push(ipD);
            }
        }
        for (let i = 0; i < comboBoxDocument.length; i++) {
            const comboBoxD = comboBoxDocument[i];
            comboBoxD.onchange = function () {
                const option = this.options;
                for (i = 0; i < option.length; i++) {
                    option[i].removeAttribute('selected');
                }
                this.options[this.selectedIndex].setAttribute('selected', 'selected');
            };
        }
        for (let i = 0; i < linkDocument.length; i++) {
            const linkD = linkDocument[i];
            linkD.setAttribute('target', '_blank');
            linkD.setAttribute('rel', 'noopener noreferrer');
        }
        this.checkNextBTNEnability(radioInput, textInput, checkInput);
    }
    updateHeader() {
        const header = Resources.getResource('screen.documets.Header');
        const currentDoc = this.get('currentStep');
        const commonDoc = this.DocumentArray.length;
        const createText = header + ' ' + currentDoc + '/' + commonDoc;
        void this.set('header', createText);
    }
    updateProgressBar() {
        const len = this.DocumentArray.length;
        const wBar = this.get('width') - 50;
        const indent = Math.floor(wBar / (len - 1));
        const arr = [];
        for (let i = 0; i < len; i++) {
            const left = indent * i;
            arr.push(left);
        }
        const index = this.get('currentStep') - 1;
        const value = arr[index];
        void this.set({
            paramLeft: arr,
            progressValue: value
        });
    }
    localize() {
        void this.set({
            nextButtonText: Resources.getResource('pageNavigation.nextButton'),
            backButtonText: Resources.getResource('pageNavigation.backButton'),
            doneButtonText: Resources.getResource('pageNavigation.doneButton')
        });
    }
    static Show(id, data) {
        const DocumentScreen = new EntitlementSubscribeDocumentScreen();
        DocumentScreen.DocumentArray = data;
        DocumentScreen.ProductID = id;
        DocumentScreen.setDocumentParam();
        MainWindowManager.AddControl(DocumentScreen);
        return DocumentScreen;
    }
    static entitlementSubscribeDocumentScreenHandlerInitialize() {
        entitlementSubscribeDocumentScreenHandler.Show = EntitlementSubscribeDocumentScreen.Show;
    }
}
TerceraWindowBase.extendWith(EntitlementSubscribeDocumentScreen, {
    data: function () {
        return {
            movable: true,
            resizable: true,
            showHeader: true,
            showFooter: false,
            focused: true,
            width: 794,
            height: 581,
            minWidth: 794,
            minHeight: 581,
            progressValue: 0,
            heightContent: 0,
            header: '',
            text_top: '',
            text_middle: '',
            currentStep: 1,
            stepsCount: null,
            canEnabledBTN: false,
            btnTooltip: ''
        };
    },
    partials: { bodyPartial: EntitlementSubscribeDocumentScreenTemplate }
});
